import { Component, inject, signal } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductDetails } from '../../models/product-details';
import { Observable, take } from 'rxjs';
import { ListOfProductsComponent } from '../../components/list-of-products/list-of-products.component';
import { NavigationExtras, Router } from '@angular/router';
import { AccountStore } from '../../store/account-store';
import { Product } from '../../models/product';
import { AppStore } from '../../../../store/app.store';

@Component({
    selector: 'app-product-list-container',
    imports: [ListOfProductsComponent],
    templateUrl: './product-list-container.component.html',
    styleUrl: './product-list-container.component.scss',
})
export class ProductListContainerComponent {
    private readonly router = inject(Router);
    public readonly store = inject(AccountStore);
    protected readonly appStore = inject(AppStore);

    private readonly productList$: Observable<ProductDetails[]> =
        this.accountService.getListOfProducts();

    public readonly signalProductList1 = toSignal(this.productList$);

    public readonly signalProductList = signal<Product[]>([]);

    constructor(private readonly accountService: AccountService) {
        this.accountService
            .getAllProducts()
            .pipe(take(1))
            .subscribe((products) => {
                this.signalProductList.set(products.data);
                const product = products.data.map(
                    (product): [number, string] => [
                        Number(product.productID),
                        product.template.productIdentifier,
                    ]
                );

                const map = new Map<number, string>(product);
                this.appStore.mapProductNames(map);
            });
    }

    onProductClick(product: Product): void {
        // this.store.updateSelectedProduct(product);
        this.store.setProduct(product);
        const extras: NavigationExtras = {
            state: product,
        };
        this.router.navigate(['/dashboard/create-contract'], extras);
    }
}
